export default __webpack_public_path__ + "static/media/15 DISNOMIA.695f5a73.png";